import React from 'react';

export const RoleIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-access-role"
      style={props.style || { color: '#757575', transform: 'scale(0.9)' }}
    />
  );
};
